import React from 'react';

import { FormattedMessage } from 'react-intl';

import LogoBamOnline from 'assets/logo-bam-online.svg';
import { ModalLayout } from 'components/b2c/ModalLayout';
import { FREE_TRIAL_DURATION_IN_MINUTES } from 'constants/freeTrial';
import { PATHS } from 'constants/pathsB2c';
import { runsInIOSApp } from 'services/helpers/browser';

import { ModalContainer, Logo, StyledMessage, StyledLink } from './CannotPlaySongModal.style';

const NOT_PREMIUM_MODAL_TRANSLATION_PREFIX = 'not-premium-modal';
const FREE_TRIAL_END_MODAL_TRANSLATION_PREFIX = 'expired-messages.free-trial-end';

interface Props {
  isOpen: boolean;
  onClose: (event: React.MouseEvent<Element, MouseEvent>) => void;
  Message: React.FunctionComponent;
}

export const NotPremiumMessage = () => (
  <>
    <FormattedMessage id={`${NOT_PREMIUM_MODAL_TRANSLATION_PREFIX}.oops`} />
    <br />
    {runsInIOSApp() ? (
      <FormattedMessage id={`${NOT_PREMIUM_MODAL_TRANSLATION_PREFIX}.mustbepremium`} />
    ) : (
      <FormattedMessage id={`${NOT_PREMIUM_MODAL_TRANSLATION_PREFIX}.message`} />
    )}
  </>
);

export const FreeTrialEndMessage = () => (
  <>
    <FormattedMessage
      id={`${FREE_TRIAL_END_MODAL_TRANSLATION_PREFIX}.trial-is-finished`}
      values={{ duration: FREE_TRIAL_DURATION_IN_MINUTES }}
    />
    <FormattedMessage id={`${FREE_TRIAL_END_MODAL_TRANSLATION_PREFIX}.discover-our-offers`} />
  </>
);

const CannotPlaySongModal: React.FC<Props> = ({ isOpen, onClose, Message }) => {
  return (
    <ModalLayout bamOnlineStyle isOpen={isOpen} onClose={onClose}>
      <ModalContainer>
        <Logo src={LogoBamOnline} />
        <StyledMessage>
          <Message />
        </StyledMessage>
        {!runsInIOSApp() && (
          <StyledLink
            to={PATHS.BAM_ONLINE_OFFERS}
            translationId={`${NOT_PREMIUM_MODAL_TRANSLATION_PREFIX}.button`}
          />
        )}
      </ModalContainer>
    </ModalLayout>
  );
};

export default CannotPlaySongModal;
